import React from 'react'
import { TableRow, TableCell, withStyles } from '@material-ui/core'
import styles from './styles'

const TableHeadComponent = props => {
  const { category, activeKeys, classes } = props
  return (
    <TableRow>
      <TableCell className={classes.headerTableCell2}>
        {category.category}
      </TableCell>
      {activeKeys.map(key => (
        <TableCell key={key} className={classes.headerTableCell} />
      ))}
    </TableRow>
  )
}

export default withStyles(styles)(TableHeadComponent)
